module.exports = __webpack_public_path__ + "static/07-6f6c80334a39a34a35ae33560b80f605.jpg";